/**
 * Docum API
 * Docum API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PlantillaDocumModel { 
    id?: number;
    nombre?: string;
    filename?: string;
    contentType?: string;
    documento?: string;
    fechaModificacion?: string;
    usuarioModificacion?: string;
}

